module.exports = __webpack_public_path__ + "static/media/desk.c0c2b3aa.jpeg";